<template>
    <v-container :class="[{ 'pa-0 ma-0': componentMode }]">

        <v-row v-if="loading">
            <v-col cols="12">
                <v-skeleton-loader type="list-item-avatar-three-line" />
                <v-skeleton-loader type="list-item-avatar-three-line" />
                <v-skeleton-loader type="list-item-avatar-three-line" />
            </v-col>
        </v-row>
        <v-row v-else :dense="componentMode">
            <v-col cols="12" v-if="chats.length === 0" class="text-center mt-3">
                <small>{{ $t('common.no_chat_history') }}</small>
            </v-col>
            <v-col cols="6" md="8" v-if="!componentMode">
                <back-button />
            </v-col>
            <v-col cols="6" md="4" v-if="!componentMode">
                <kimsa-text-field :placeholder="$t('common.search')" :value="search" @change="search = $event"
                    icon="mdi-magnify" outlined dense clearable no-elevation />
            </v-col>
            <v-col cols="12" :md="componentMode ? 12 : 6" :lg="componentMode ? 12 : 4" v-for="chat in chatsFiltered"
                :key="chat.id">
                <student-chat-card @click="onShowChat(chat)" :chat="chat" />
            </v-col>
            <v-col cols="12" v-if="chatsFiltered.length === 0" class="text-center mt-3">
                <small>{{ $t('common.no_results') }}</small>
            </v-col>
        </v-row>

        <chat-dialog @hideChat="onHideChat" :clientId="studentId" ref="chat" />

    </v-container>
</template>

<script>

import StudentChatCard from '@/components/common/cards/StudentChatCard'
import ChatDialog from '@/components/student/ChatDialog'
import { db } from '@/utils/Firebase'
import { UserIndex } from '@/utils/Algolia'
import _map from 'lodash/map'
import _flatten from 'lodash/flatten'
import _uniq from 'lodash/uniq'
import BackButton from "@/components/common/BackButton";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

export default {
    components: {
        KimsaTextField,
        BackButton,
        StudentChatCard,
        ChatDialog,
    },
    props: {
        componentMode: {
            type: Boolean,
            default: false,
        },
        searchChat: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            loading: false,
            chats: [],
            studentId: null,
            search: '',
        }
    },
    computed: {
        chatsFiltered(vm = this) {
            if (!vm.search || vm.search.length < 3) return vm.chats
            return vm.chats.filter(chat =>
                chat.participants.some(participant =>
                    participant.name?.toLowerCase().includes(vm.search.toLowerCase()) || participant.email?.toLowerCase().includes(vm.search.toLowerCase())
                )
            )
        }
    },
    mounted() {
        const vm = this
        vm.loadChats()
    },
    methods: {
        async loadChats() {
            const vm = this
            vm.loading = true
            let allChats = []

            let query = db.collection('privateChats')
                .where('participants', 'array-contains', vm.currentUser.uid)
                .orderBy('lastMessage.timestamp', 'desc')
            if (vm.componentMode) query = query.where('lastMessage.read', '==', false).limit(6);
            const chatRef = await query.get();

            chatRef.docs.forEach(chat => {
                allChats.push({
                    ...chat.data(),
                    id: chat.id
                })
            })

            if (vm.componentMode && allChats.length < 6) {
                let remainingChats = 6 - allChats.length;
                let readChatRef = await db.collection('privateChats')
                    .where('participants', 'array-contains', vm.currentUser.uid)
                    .where('lastMessage.read', '==', true)
                    .orderBy('lastMessage.timestamp', 'desc')
                    .limit(remainingChats)
                    .get()
                readChatRef.docs.forEach(chat => {
                    allChats.push({
                        ...chat.data(),
                        id: chat.id
                    });
                });
            }

            const allParticipantIDs = _uniq(_flatten(_map(allChats, 'participants')))
            let allUsers = []
            if (allParticipantIDs.length > 0) {
                const algoliaResult = await UserIndex.search('',
                    {
                        filters: `objectID:${allParticipantIDs.join(' OR objectID:')}`,
                        hitsPerPage: 10000,
                    })
                allUsers = algoliaResult.hits
            }

            for (let chat of allChats) {
                if (chat.lastMessage) {
                    chat.lastMessage.from = allUsers.find(user => user.objectID === chat.lastMessage?.from)
                    chat.participants = allUsers.filter(user => chat.participants.includes(user.objectID))
                }
            }

            vm.chats = allChats.filter(chat => chat.lastMessage?.from)

            let messagedNoRead = vm.chats.filter(chat => chat.lastMessage?.from?.objectID !== vm.currentUser.uid && !chat.lastMessage?.read).length
            let myMessagesNoRead = vm.account?.counter?.messages || 0
            if (messagedNoRead !== myMessagesNoRead) await db.collection('users').doc(vm.currentUser.uid).update({ 'counter.messages': messagedNoRead })

            vm.loading = false
        },
        onShowChat(chat) {
            const vm = this
            let notMe = chat.participants.find(usr => usr.objectID !== vm.currentUser.uid)
            vm.studentId = notMe.objectID || null
            vm.$refs.chat.show()
        },
        onHideChat() {
            const vm = this
            vm.studentId = null
            vm.loadChats()
            vm.$refs.chat.client = null
        }
    },
    watch: {
        searchChat(val) {
            this.search = val
        }
    }
}
</script>
